<template>
  <section v-show="inited" class="popup-w">
    <transition name="ani-mask">
      <template v-if="!lazyRender">
        <div
          class="action-sheet--mask"
          v-show="status"
          @click="maskClose"
          :style="{ maskStyle, transitionDuration }"
        ></div>
      </template>
      <template v-else>
        <div
          class="action-sheet--mask"
          v-if="status"
          @click="maskClose"
          :style="{ maskStyle, transitionDuration }"
        ></div>
      </template>
    </transition>
    <transition name="ani-w" @onAfterEnter="onOpened" @onAfterLeave="onClosed">
      <template v-if="!lazyRender">
        <div
          class="action-sheet--w"
          v-show="status"
          :style="{ transitionDuration }"
        >
          <div class="action-sheet--ctn" :class="{ round }">
            <slot></slot>
            <!--不要删除,兼容iphonex -->
            <div class="menu_wkBox_back_box"></div>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          class="action-sheet--w"
          v-if="status"
          :style="{ transitionDuration }"
        >
          <div class="action-sheet--ctn" :class="{ round }">
            <slot></slot>
            <!--不要删除,兼容iphonex -->
            <div class="menu_wkBox_back_box"></div>
          </div>
        </div>
      </template>
    </transition>
  </section>
</template>
<script>
import props from '../lib/props'
import mixin from '../mixins'
export default {
  name: 'popup',
  mixins: [mixin],
  props,
  data() {
    return {
      status: this.value,
      scrollTop: 0,
      inited: this.value
    }
  },
  computed: {
    transitionDuration() {
      return this.duration + 'ms'
    }
  },
  methods: {
    maskClose() {
      if (this.closeOnClickMask) {
        this.hide()
      }
    },
    hide() {
      // bug：下方注释代码极端环境下比如连续点击会引起bug
      //比如 temp1.click(); setTimeout(()=>temp2.click(),100);setTimeout(()=>temp1.click(),200);setTimeout(()=>temp2.click(),300);setTimeout(()=>temp1.click(),400);
      // setTimeout(() => {
      //   this.inited = false
      // }, this.duration)
      this.status = false
      this.$emit('input', false)
      this.removeLock(this.scrollTop)
      this.onClosed()
    },
    show() {
      this.inited = true
      this.status = true
      this.addLock()
      this.onOpened()
    },
    addLock() {
      if (!this.lockScroll) return
      const doc = document
      this.scrollTop = doc.body.scrollTop || doc.documentElement.scrollTop
      doc.body.scrollTop = 0
      doc.body.classList.add('of-hide')
      doc.documentElement.classList.add('of-hide')
    },
    removeLock(scrollTop = 0) {
      const doc = document
      doc.body.classList.remove('of-hide')
      doc.documentElement.classList.remove('of-hide')
      doc.body.scrollTop = doc.documentElement.scrollTop = scrollTop
    }
  },
  beforeDestroy() {
    this.removeLock(this.scrollTop)
  },
  watch: {
    value(n) {
      if (n) {
        this.show()
      } else {
        this.status && this.hide()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$popname: '.action-sheet--';
$aniname: '.ani-';
.popup-w {
  will-change: auto;
  -webkit-overflow-scrolling: touch;
}
#{$popname}mask,
#{$popname}w {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
}
#{$popname}mask {
  top: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
  will-change: opacity;
}
#{$popname}w {
  display: flex;
  align-items: flex-end;
  z-index: 101;
  will-change: transform;
  // backface-visibility: hidden;
  // transform: translate(0, 100%);
}

#{$popname}ctn {
  position: relative;
  min-height: 1rem;
  width: 100%;
  background-color: #fff;
  max-height: 92vh;
  &.round {
    border-radius: 0.24rem 0.24rem 0 0;
  }
  overflow: hidden;
}
#{$aniname}mask-enter,
#{$aniname}mask-leave-to {
  opacity: 0;
}
#{$aniname}mask-leave-active,
#{$aniname}mask-enter-active {
  transition: opacity 300ms;
}
#{$aniname}w-enter,
#{$aniname}w-leave-to {
  transform: translate3d(0, 100%, 0);
}
#{$aniname}w-leave-active,
#{$aniname}w-enter-active {
  transition: transform 300ms;
}
</style>
